import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-slider mb-3" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row gx-5" }
const _hoisted_4 = { class: "col-md-7 text-start" }
const _hoisted_5 = { class: "col-md-5 border-start" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "fs-5" }

import { ref, computed, watch } from "vue";
import { formatter } from "@/shared/ts/formatter";
import GMath from "@/shared/ts/gMath";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProviderCostEstimator',
  props: {
    industryAverageCharge: { type: Number, required: true },
    upperText: { type: String, default: "" },
    lowerText: { type: String, default: "" }
},
  emits: ['charge-rate-changed'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

__expose({ invokeChangeEvent });

const annualChargeModel = ref(1);

watch(() => props.industryAverageCharge, () => invokeChangeEvent());

watch(() => annualChargeModel.value, () => {
    emit('charge-rate-changed', annualChargeModel.value, industryCost.value);
});

const industryCost = computed<null | number>(() => {
  const adjustedChargeRate = annualChargeModel.value / 1.5;
  const cost = props.industryAverageCharge * adjustedChargeRate;
  const toNearestHundred = GMath.round(cost, -2);
  return toNearestHundred;
});

const industryCostText = computed<string>(() => {
  return industryCost.value == null ? "" : formatter.formatCurrency(industryCost.value);
});

const annualChargeText = computed<string>(() => {
  const integer = Math.floor(annualChargeModel.value);
  let mod = annualChargeModel.value < 1
      ? annualChargeModel.value
      : annualChargeModel.value % integer;

  let annualCharge = "";

  switch (mod) {
    case 0:
      annualCharge = `${integer.toFixed(0)}.0% `;
      break;
    default:
      mod = GMath.round(mod, 1);
      annualCharge = `${integer.toFixed(0)}.${mod
        .toString()
        .replace("0.", "")}%`;
  }

  // Use &numsp; to stabilise different decimal string lengths, e.g. .replaceAll(" ", "&numsp;");
  return annualCharge;
});

function invokeChangeEvent() {
  emit('charge-rate-changed', annualChargeModel.value, industryCost.value);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", null, _toDisplayString(__props.upperText), 1),
          _withDirectives(_createElementVNode("input", {
            type: "range",
            class: "form-range my-3",
            id: "annualCharge",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((annualChargeModel).value = $event)),
            min: "0.4",
            max: "2",
            step: "0.1"
          }, null, 512), [
            [_vModelText, annualChargeModel.value]
          ]),
          _createElementVNode("p", null, _toDisplayString(__props.lowerText), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "mb-1" }, [
            _createElementVNode("strong", null, "Annual Charge")
          ], -1)),
          _createElementVNode("span", {
            class: "display-5",
            innerHTML: annualChargeText.value
          }, null, 8, _hoisted_6),
          _cache[2] || (_cache[2] = _createElementVNode("p", { class: "mb-1 mt-3" }, "Expected charges in retirement", -1)),
          _createElementVNode("span", _hoisted_7, _toDisplayString(industryCostText.value), 1)
        ])
      ])
    ])
  ]))
}
}

})